import { getRandomString } from '@/helpers/stringHelper'

export default class WebWorkerService {
	constructor(workerName) {
		// console.log('WebWorkerService constructor')
		this.workerPaths = {
			unzippingDataWorker: '/workers/unzippingDataWorker.js',
			geojsonWorker: '/workers/geojsonWorker.js',
		}

		this.myWorker = new Worker(this.workerPaths[workerName])

		this.jobs = {}

		this.myWorker.onmessage = (e) => {
			const result = e.data
			const { jobId, payload } = result
			const job = this.jobs[jobId]
			if (job) {
				job.resolve(payload)
			}
		}

		this.myWorker.onerror = (e) => {
			console.log('Error in worker', e)
			const { jobId } = e.data
			const job = this.jobs[jobId]
			if (job) {
				job.reject(e)
			}
		}
	}

	runJob({cmd, payload}) {
		return new Promise((resolve, reject) => {
			const jobId = getRandomString(10)
			this.jobs[jobId] = {
				id: jobId,
				resolve,
				reject,
			}
			this.myWorker.postMessage({
				jobId,
				cmd,
				payload,
			})
		})
	}
}
